/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiCostcentersQueryResponse,
  GetApiCostcentersQueryParams,
} from '../models/GetApiCostcenters.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiCostcentersQueryResponseSchema } from '../zod/getApiCostcentersSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiCostcentersQueryKey = (
  params: GetApiCostcentersQueryParams,
) => [{ url: '/api/costCenters' }, ...(params ? [params] : [])] as const;

export type GetApiCostcentersQueryKey = ReturnType<
  typeof getApiCostcentersQueryKey
>;

/**
 * {@link /api/costCenters}
 */
export async function getApiCostcenters(
  params: GetApiCostcentersQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiCostcentersQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/costCenters`,
    params,
    ...requestConfig,
  });
  return getApiCostcentersQueryResponseSchema.parse(res.data);
}

export function getApiCostcentersQueryOptions(
  params: GetApiCostcentersQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiCostcentersQueryKey(params);
  return queryOptions<
    GetApiCostcentersQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiCostcentersQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiCostcenters(params, config);
    },
  });
}

/**
 * {@link /api/costCenters}
 */
export function useGetApiCostcenters<
  TData = GetApiCostcentersQueryResponse,
  TQueryData = GetApiCostcentersQueryResponse,
  TQueryKey extends QueryKey = GetApiCostcentersQueryKey,
>(
  params: GetApiCostcentersQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiCostcentersQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiCostcentersQueryKey(params);

  const query = useQuery(
    {
      ...getApiCostcentersQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
